/* ==========================================================================
   TJÅKKO "Hitta din storlek": the store wide size wizard.

   Markup: snippets/tj-size-wizard.liquid (rendered once from the header).
   Opens from any [data-tj-size-open] (header link, drawer bar) and from
   #hitta-din-storlek in the URL or in a link. The trigger keeps its href as
   the no JS fallback.

   The size per product is assets/tj-size-rule.js applied to that product's
   own table, exactly as the product page finder applies it. Product data
   comes from sections/tj-size-wizard-data.liquid through the Section
   Rendering API: one request per collection, cached for the session.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__tjSizeWizard) return;
  window.__tjSizeWizard = true;

  var HASH = '#hitta-din-storlek';
  var PAGE = 24;
  var CACHE_TTL = 15 * 60 * 1000;
  var STEPS = ['who', 'foot', 'type'];
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var dlg = null;
  var R = null;
  var trigger = null;
  var openedByHash = false;
  var escPending = false;
  var memo = {};
  var state = { step: 'who', who: null, collection: null, allLabel: '', child: false, foot: NaN, type: null, typeLabel: '', shown: 0, matches: [] };

  function $(sel, root) { return (root || dlg).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || dlg).querySelectorAll(sel)); }
  function txt(name) { return dlg.getAttribute('data-text-' + name) || ''; }
  function fill(tpl, values) {
    var out = String(tpl || '');
    Object.keys(values).forEach(function (k) { out = out.split('{' + k + '}').join(values[k]); });
    return out;
  }
  function cm(v) { return (Math.round(v * 10) / 10).toFixed(1).replace('.', ','); }

  /* ---------- money: Shopify's formatMoney, for the store's own format ---------- */
  function money(cents, format) {
    var value = Number(cents) || 0;
    function delimit(n, prec, thou, dec) {
      var fixed = (n / 100).toFixed(prec);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    var fmt = String(format || '{{amount_no_decimals}} kr');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var amount;
    switch (key) {
      case 'amount_no_decimals': amount = delimit(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': amount = delimit(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': amount = delimit(value, 0, '.', ','); break;
      case 'amount_with_space_separator': amount = delimit(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': amount = delimit(value, 0, ' ', ','); break;
      default: amount = delimit(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount).replace(/<[^>]*>/g, '');
  }

  /* ---------- open, close, focus ---------- */
  function setup() {
    dlg = document.getElementById('tj-size-wizard');
    R = window.TJSizeRule;
    if (!dlg || !R || typeof dlg.showModal !== 'function') return false;
    if (dlg.parentNode !== document.body) document.body.appendChild(dlg);

    $$('[data-tjw-close]').forEach(function (b) { b.addEventListener('click', function () { close(); }); });
    $('[data-tjw-back]').addEventListener('click', back);
    $$('.tjw-choice').forEach(function (b) { b.addEventListener('click', function () { chooseWho(b); }); });
    $('[data-tjw-foot-form]').addEventListener('submit', function (e) { e.preventDefault(); submitFoot(); });
    $('[data-tjw-foot]').addEventListener('input', function () { showError(false); });
    $('[data-tjw-show]').addEventListener('click', showResults);
    $('[data-tjw-edit]').addEventListener('click', function () { go('foot'); });
    $('[data-tjw-more]').addEventListener('click', more);

    /* a click on the dimmed page outside the sheet closes, as the drawer's scrim does */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    /* Escape: closed on keyup, not keydown. Focus goes back to the trigger on close, and the
       theme's drawer closes itself on an Escape keyup, so the keyup must be ours. */
    dlg.addEventListener('cancel', function (e) {
      e.preventDefault();
      if (!escPending) close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); escPending = true; }
      if (e.key === 'Tab') trapTab(e);
    });
    window.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape' || !escPending) return;
      escPending = false;
      e.stopPropagation();
      close();
    }, true);
    return true;
  }

  function focusables() {
    return $$('button, [href], input, [tabindex]:not([tabindex="-1"])').filter(function (el) {
      return !el.disabled && !el.closest('[hidden]') && el.getClientRects().length > 0 &&
        (el.type !== 'radio' || el.checked);
    });
  }

  /* the modal dialog already makes the page inert; this keeps Tab cycling inside the sheet
     instead of leaving for the browser chrome */
  function trapTab(e) {
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dlg.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function open(from) {
    if (!dlg && !setup()) return false;
    trigger = from || document.activeElement;
    if (dlg.open) return true;
    dlg.showModal();
    document.documentElement.classList.add('tjw-open');
    go(state.step === 'results' && state.matches ? 'results' : state.step, true);
    return true;
  }

  function close() {
    if (!dlg || !dlg.open) return;
    dlg.close();
    document.documentElement.classList.remove('tjw-open');
    if (openedByHash && location.hash === HASH) {
      try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) { /* ignore */ }
    }
    openedByHash = false;
    var to = trigger;
    trigger = null;
    if (to && to.isConnected && typeof to.focus === 'function') to.focus({ preventScroll: true });
  }

  /* ---------- steps ---------- */
  function go(step, opening) {
    state.step = step;
    $$('.tjw-step').forEach(function (s) {
      var on = s.getAttribute('data-step') === step;
      s.hidden = !on;
      if (on && !REDUCE && !opening) {
        s.classList.remove('is-entering');
        void s.offsetWidth;
        s.classList.add('is-entering');
      }
    });
    var idx = STEPS.indexOf(step);
    $('[data-tjw-back]').hidden = step === 'who';
    var progress = idx > -1 ? fill(txt('progress'), { step: idx + 1, total: STEPS.length }) : '';
    $('[data-tjw-progress]').textContent = progress;
    $('[data-tjw-body]').scrollTop = 0;

    var live = $('[data-tjw-live]');
    if (idx > -1) live.textContent = progress + ': ' + txt(step);

    window.requestAnimationFrame(function () {
      if (step === 'foot') {
        $('[data-tjw-foot]').focus({ preventScroll: true });
      } else {
        var h = $('.tjw-step[data-step="' + step + '"] .tjw-step__h');
        if (h) h.focus({ preventScroll: true });
      }
    });
  }

  function back() {
    var order = ['who', 'foot', 'type', 'results'];
    var i = order.indexOf(state.step);
    go(order[Math.max(0, i - 1)]);
  }

  function audience(child) {
    $$('[data-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-for') !== (child ? 'child' : 'adult');
    });
    var input = $('[data-tjw-foot]');
    input.placeholder = input.getAttribute(child ? 'data-ph-child' : 'data-ph-adult');
  }

  function chooseWho(btn) {
    var who = btn.getAttribute('data-who');
    if (state.who !== who) state.matches = null;
    state.who = who;
    state.collection = btn.getAttribute('data-collection');
    state.allLabel = btn.getAttribute('data-all-label') || '';
    state.child = who === 'barn';
    $$('.tjw-choice').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    $$('.tjw-chips').forEach(function (ul) { ul.hidden = ul.getAttribute('data-types-for') !== who; });
    audience(state.child);
    var input = $('[data-tjw-foot]');
    if (input.value && !valid(R.parseFoot(input.value))) input.value = '';
    go('foot');
  }

  function valid(v) {
    var b = R.bounds(state.child);
    return !isNaN(v) && v >= b.min && v <= b.max;
  }

  function showError(on) {
    var err = $('[data-tjw-err]');
    var input = $('[data-tjw-foot]');
    err.textContent = on ? err.getAttribute(state.child ? 'data-child' : 'data-adult') : '';
    if (on) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  }

  function submitFoot() {
    var input = $('[data-tjw-foot]');
    var v = R.parseFoot(input.value);
    if (!valid(v)) {
      showError(true);
      input.focus();
      return;
    }
    showError(false);
    if (v !== state.foot) state.matches = null;
    state.foot = v;
    go('type');
  }

  function chosenType() {
    var input = $('.tjw-chips[data-types-for="' + state.who + '"] input:checked');
    if (!input) return { handle: state.collection, label: '' };
    var label = input.parentNode.textContent.trim();
    return { handle: input.value, label: input.value === state.collection ? '' : label };
  }

  /* ---------- data: one request per collection, cached ---------- */
  function cacheKey(handle) { return 'tjw:v1:' + (dlg.getAttribute('data-root') || '/') + handle; }

  function readCache(handle) {
    if (memo[handle]) return memo[handle];
    try {
      var raw = window.sessionStorage.getItem(cacheKey(handle));
      if (!raw) return null;
      var hit = JSON.parse(raw);
      if (!hit || Date.now() - hit.at > CACHE_TTL) return null;
      memo[handle] = Promise.resolve(hit.data);
      return memo[handle];
    } catch (e) { return null; }
  }

  function fetchPage(handle, page, attempt) {
    var root = dlg.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    var url = root + 'collections/' + encodeURIComponent(handle) + '?section_id=tj-size-wizard-data' + (page > 1 ? '&page=' + page : '');
    /* no Accept header: an Accept json request makes Shopify answer with something else */
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (res.status === 429 && attempt < 2) {
        return new Promise(function (ok) { setTimeout(ok, 2500 * (attempt + 1)); })
          .then(function () { return fetchPage(handle, page, attempt + 1); });
      }
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text().then(function (html) {
        var m = html.match(/<script type="application\/json" data-tj-size-data>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('no data');
        return JSON.parse(m[1]);
      });
    });
  }

  function load(handle) {
    var hit = readCache(handle);
    if (hit) return hit;
    var all = [];
    var meta = null;
    function step(page) {
      return fetchPage(handle, page, 0).then(function (data) {
        meta = meta || data;
        all = all.concat(data.products || []);
        if (data.next && page < 20) return step(data.next);
        return { collection: meta.collection, title: meta.title, money: meta.money, products: all };
      });
    }
    memo[handle] = step(1).then(function (data) {
      try { window.sessionStorage.setItem(cacheKey(handle), JSON.stringify({ at: Date.now(), data: data })); } catch (e) { /* full or blocked */ }
      return data;
    }, function (err) {
      delete memo[handle];
      throw err;
    });
    return memo[handle];
  }

  /* ---------- matching ---------- */
  function match(data) {
    var ruleMin = parseFloat(dlg.getAttribute('data-rule-min')) || 1.0;
    var ruleMax = parseFloat(dlg.getAttribute('data-rule-max')) || 1.5;
    var stats = { products: 0, noTable: 0, noFit: 0, notSold: 0, soldOut: 0, shown: 0 };
    var out = [];
    (data.products || []).forEach(function (p) {
      stats.products++;
      var prep = p.tab ? R.prepare(p.tab, { sizeCol: 0, lenCol: 1 }) : null;
      if (!prep || !p.vars || !p.vars.length) { stats.noTable++; return; }
      var res = R.pick(prep, state.foot, { ruleMin: ruleMin, ruleMax: ruleMax });
      if (res.status !== 'ok') { stats.noFit++; return; }
      var size = res.pick.size;
      var sized = p.vars.filter(function (v) { return R.sameSize(v.s, size); });
      if (!sized.length) { stats.notSold++; return; }
      var v = sized.filter(function (x) { return x.a; })[0];
      if (!v) { stats.soldOut++; return; }
      stats.shown++;
      out.push({ p: p, v: v, size: v.s || size });
    });
    window.__tjwStats = stats;
    return out;
  }

  /* ---------- results ---------- */
  function status(kind, data) {
    var box = $('[data-tjw-status]');
    box.textContent = '';
    box.hidden = !kind;
    box.className = 'tjw-res__status' + (kind ? ' is-' + kind : '');
    if (!kind) return;
    var p = document.createElement('p');
    p.className = 'tjw-res__msg';
    if (kind === 'loading') {
      p.textContent = txt('loading');
      box.setAttribute('role', 'status');
      box.appendChild(p);
      return;
    }
    box.removeAttribute('role');
    if (kind === 'error') {
      p.textContent = txt('error');
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'tjw-btn tjw-btn--ghost';
      retry.textContent = txt('retry');
      retry.addEventListener('click', showResults);
      box.appendChild(p);
      box.appendChild(retry);
      return;
    }
    p.textContent = txt('empty');
    box.appendChild(p);
    var type = chosenType();
    var a = document.createElement('a');
    a.className = 'tjw-link';
    var root = dlg.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    a.href = root + 'collections/' + type.handle;
    a.textContent = type.label ? fill(txt('empty-type'), { type: type.label.toLowerCase() }) : state.allLabel;
    box.appendChild(a);
  }

  function card(m, format) {
    var root = dlg.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    var li = document.createElement('li');
    li.className = 'tjw-card';
    var a = document.createElement('a');
    a.className = 'tjw-card__a';
    a.href = root + 'products/' + m.p.h + '?variant=' + m.v.id;

    var media = document.createElement('span');
    media.className = 'tjw-card__media';
    var src = m.v.img || m.p.img;
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 480;
      img.height = Math.round(480 / (m.p.r || 1));
      media.appendChild(img);
    }
    var chip = document.createElement('span');
    chip.className = 'tjw-chipsize';
    var label = fill(txt('chip'), { size: '\u0000' }).split('\u0000');
    chip.appendChild(document.createTextNode(label[0]));
    var b = document.createElement('b');
    b.textContent = m.size;
    chip.appendChild(b);
    if (label[1]) chip.appendChild(document.createTextNode(label[1]));
    media.appendChild(chip);

    var vendor = document.createElement('span');
    vendor.className = 'tjw-card__v';
    vendor.textContent = m.p.v;
    var title = document.createElement('span');
    title.className = 'tjw-card__t';
    title.textContent = m.p.t;
    var price = document.createElement('span');
    price.className = 'tjw-card__p';
    if (m.v.cp && m.v.cp > m.v.p) {
      price.classList.add('is-sale');
      var now = document.createElement('span');
      now.innerHTML = '<span class="tjw-sr"></span>';
      now.firstChild.textContent = txt('sale') + ' ';
      now.appendChild(document.createTextNode(money(m.v.p, format)));
      var was = document.createElement('s');
      was.innerHTML = '<span class="tjw-sr"></span>';
      was.firstChild.textContent = txt('regular') + ' ';
      was.appendChild(document.createTextNode(money(m.v.cp, format)));
      price.appendChild(now);
      price.appendChild(was);
    } else {
      price.textContent = money(m.v.p, format);
    }
    a.appendChild(media);
    a.appendChild(vendor);
    a.appendChild(title);
    a.appendChild(price);
    li.appendChild(a);
    return li;
  }

  function render(from) {
    var grid = $('[data-tjw-grid]');
    var to = Math.min(state.matches.length, from + PAGE);
    var frag = document.createDocumentFragment();
    for (var i = from; i < to; i++) frag.appendChild(card(state.matches[i], state.money));
    grid.appendChild(frag);
    state.shown = to;
    $('[data-tjw-more]').hidden = state.shown >= state.matches.length;
    return grid.children[from];
  }

  function more() {
    var first = render(state.shown);
    var link = first && first.querySelector('a');
    if (link) link.focus();
  }

  function heading() {
    var tpl = state.child ? txt('results-child') : txt('results');
    $('[data-tjw-res-h]').textContent = fill(tpl, { foot: cm(state.foot) });
  }

  function showResults() {
    var type = chosenType();
    state.type = type.handle;
    heading();
    $('[data-tjw-grid]').textContent = '';
    $('[data-tjw-more]').hidden = true;
    $('[data-tjw-res-count]').textContent = '';
    status('loading');
    go('results');
    var asked = { foot: state.foot, type: state.type };
    load(type.handle).then(function (data) {
      if (asked.foot !== state.foot || asked.type !== state.type) return;
      state.money = data.money;
      state.matches = match(data);
      var n = state.matches.length;
      $('[data-tjw-res-count]').textContent = !n ? '' : n === 1 ? txt('count-one') : fill(txt('count-other'), { count: n });
      if (!n) { status('empty'); return; }
      status(null);
      render(0);
      $('[data-tjw-live]').textContent = $('[data-tjw-res-h]').textContent + '. ' + $('[data-tjw-res-count]').textContent;
    }).catch(function () {
      if (asked.foot !== state.foot || asked.type !== state.type) return;
      status('error');
    });
  }

  /* ---------- triggers ---------- */
  function isWizardLink(el) {
    if (!el) return false;
    if (el.hasAttribute('data-tj-size-open')) return true;
    var href = el.getAttribute('href') || '';
    return href.indexOf(HASH) !== -1;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target.closest ? e.target.closest('[data-tj-size-open], a[href*="' + HASH + '"]') : null;
    if (!isWizardLink(el)) return;
    if (open(el)) e.preventDefault();
  }, true);

  function fromHash() {
    if (location.hash !== HASH) return;
    openedByHash = true;
    if (!open(null)) openedByHash = false;
  }
  window.addEventListener('hashchange', fromHash);

  window.TJSizeWizard = { open: open, close: close };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
  else fromHash();
})();
